import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "theme/libs/styled";
import TextStyles from "theme/components/text/TextStyles";
import RelationsProduct from "./RelationsProduct";
import Waterfall from "theme/layouts/Waterfall";
import PackageProductCard from "../products/ProductCard/PackageProductCard";

const Wrapper = styled("div")`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;

    &[data-relations="true"] {
        ${({ theme }) => theme.above.tabletSm} {
            flex-direction: row;
        }

        ${({ theme }) => theme.above.tabletLg} {
            flex-direction: column;
        }
    }
`;

const AdditionalProducts = ({
    products,
    heading = "",
    type = "",
    selectProductVariantCallback,
    selectedProductVariants,
    textStyle = "Myriad Pro/20-100-semibold",
    ...props
}) => {
    if (!products) {
        return null;
    }

    // can we remove this?
    const [activeDropdown, setActiveDropdown] = useState(
        products.reduce((result, _current, index) => {
            result[index] = false;
            return result;
        }, {}),
    );

    const handleMenu = (i) => {
        const currentState = activeDropdown[i];
        setActiveDropdown({ ...activeDropdown, [i]: !currentState });
    };

    return (
        <Waterfall rowGap="24px">
            {heading && (
                <TextStyles as="h2" textStyles={textStyle} pt="24px">
                    {heading}
                </TextStyles>
            )}
            <Wrapper data-relations={type === "relation"} {...props}>
                {products.map((product, i) => {
                    return type === "package" ? (
                        <PackageProductCard key={i} {...product} />
                    ) : (
                        // <PackageItem
                        //     key={i}
                        //     i={i}
                        //     product={product}
                        //     selectedProductVariants={selectedProductVariants}
                        //     selectProductVariantCallback={selectProductVariantCallback}
                        //     activeDropdown={activeDropdown}
                        //     handleMenu={handleMenu}
                        // />
                        <RelationsProduct
                            key={i}
                            i={i}
                            product={product}
                            type={type}
                            activeDropdown={activeDropdown}
                            handleMenu={handleMenu}
                        />
                    );
                })}
            </Wrapper>
        </Waterfall>
    );
};

AdditionalProducts.propTypes = {
    heading: PropTypes.string,
    products: PropTypes.array.isRequired,
    selectProductVariantCallback: PropTypes.func.isRequired,
    selectedProductVariants: PropTypes.object.isRequired,
    textStyle: PropTypes.string,
    type: PropTypes.string,
};

export default AdditionalProducts;
